import { render } from "./SnippetVideoPlayer.vue?vue&type=template&id=21a7fcb4&scoped=true"
import script from "./SnippetVideoPlayer.vue?vue&type=script&lang=js"
export * from "./SnippetVideoPlayer.vue?vue&type=script&lang=js"

import "./SnippetVideoPlayer.vue?vue&type=style&index=0&id=21a7fcb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a7fcb4"]])

export default __exports__